import { FlexView } from '@facile-it/shark-morph/components'
import * as React from 'react'
import type { Unit } from '../Unit'
import type { Structure } from '../formBuilder'
import { buildItemProps } from './buildItemProp'

export namespace UnitHtmlRenderer {
    export interface Props {
        unit: Unit.HtmlUnit
        view: Structure<string>[0]['rows'][0]['units'][0]['view']
    }
}

export class UnitHtmlRenderer extends React.PureComponent<UnitHtmlRenderer.Props> {
    render() {
        return <FlexView.Item {...buildItemProps(this.props.view)}>{this.props.unit.element}</FlexView.Item>
    }
}
